/* eslint-disable */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ECharts from 'echarts-for-react';
import { Button, CardContent, Divider, FormControl, Modal } from "@mui/material";
import { getdDiagnosisResultChainGraphDayByQuery, getDiagnosisResultNoiseByDayByQuery, getDiagnosisResultVibrationSensorsGraphDayByQuery, getEquipmentTemperatureGraphDayByQuery } from "components/axios/equipmentAlertsAxios";
import MainCard from "components/MainCard";
import CustomDatePicker2 from "components/date_picker/CustomDatePicker2";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import Chip from '@mui/material/Chip';
import { useTheme } from "components/ThemeContext";

const chartDataInit = {
    darkmode:true,
    textStyle : {
        color : '#ffffff'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
        data : [],
        left : 'center',
        top: 0,
        backgroundColor : '#fff'
    //   orient: 'vertical',
    //   left: 'left',
    //   textStyle : {
    //     color : '#ffffff'
    //   },
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: [ ]
    },
    yAxis: {
        type: 'value'
    },
    series: [ ]
}

const EquipmentPartSensorsGraphsLayer = ({equipment, sensorPosition, equipmentPartId, equipmentPartPosition, equipmentPartName, type="S0"}) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const { mode } = useTheme();
    const textColor = mode === 'white' ? '#262626' : '#ffffff';
    const bgColor = mode === 'white' ? '#f9f9fa' : '#2f2f2f';

    const chartDataInit = {
        // darkmode:true,
        chart: {
            background: '#2f2f2f',
            foreColor: '#ffffff',
        },
        textStyle : {
            color : textColor
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data : [],
            left : 'center',
            top: 0,
            backgroundColor : bgColor,
            textStyle: {
                color: textColor
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [ ]
        },
        yAxis: {
            type: 'value'
        },
        series: [ ]
    }
    
    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const [searchStartDateText, setSearchStartDateText] = useState('');
    const [searchEndDateText, setSearchEndDateText] = useState('');
    const [options, setOptions] = useState({chartDataInit});
    const [title, setTitle] = useState(null);
    const [bullet, setBullet] = useState('popbullet.png');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
               // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const handleOpen = () => {
        setOpen(true);
    }
    const handleClose = () => setOpen(false);

    const handleSearch = (event) => {
        event.preventDefault();

        if (searchStartDateText === null || searchStartDateText === '' || searchEndDateText === null || searchEndDateText === '') {
            alertMessage = t('message.common.alert.period.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (searchStartDateText !== null && searchStartDateText !== '' && !regexDate.test(searchStartDateText)) {
            alertMessage = t('message.common.alert.search.startDate.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (searchEndDateText !== null && searchEndDateText !== '' && !regexDate.test(searchEndDateText)) {
            alertMessage = t('message.common.alert.search.endDate.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }
        graphInfo();
    };

    const graphInfo = () => {
        let graphDateParam = {};
        if (searchStartDateText && searchEndDateText) {
            graphDateParam.startDay = searchStartDateText;
            graphDateParam.endDay = searchEndDateText;
        }
        if (type === "S0" || type === "S1") { // 진동센서S0, 소음센서S0, 온도센서S1
            if(sensorPosition && equipment) {
                let graphParam = {...graphDateParam, "sensorPosition.id":sensorPosition.id};
                setOptions(null)
                if (type === "S0") {
                    if (sensorPosition.sensorType === 'V') {    // 진동센서
                        getDiagnosisResultVibrationSensorsGraphDayByQuery(graphParam).then((data)=> {
                            if (data && data._embedded) {
                                let list = data._embedded.groupByDailyDiagnosisResultVibrations;
                                list.sort(function(a,b) {
                                    const upperCaseA = a.ymd.toUpperCase();
                                    const upperCaseB = b.ymd.toUpperCase();
                                    if (upperCaseA > upperCaseB) return 1;
                                    if (upperCaseA < upperCaseB) return -1;
                                    if (upperCaseA === upperCaseB) return 0;
                                });
                                let optionsCopy = {...chartDataInit};
                                let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
                                
                                let overallXs = [];
                                let overallYs = [];
                                let overallZs = [];
                                list.map(function(item, i) {
                                    chartDataCopy.xAxis.data.push(item.ymd);
                                    overallXs.push(item.overallShaft.toFixed(2));
                                    overallYs.push(item.overallHorizon.toFixed(2));
                                    overallZs.push(item.overallVertical.toFixed(2));
                                });
                                chartDataCopy.series.push({name:t('message.common.subtitle.axis'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : overallXs});
                                chartDataCopy.series.push({name:t('message.common.subtitle.radius'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : overallYs});
                                chartDataCopy.series.push({name:t('message.common.subtitle.vertical'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : overallZs});
                                chartDataCopy.legend.data.push(t('message.common.subtitle.axis'));
                                chartDataCopy.legend.data.push(t('message.common.subtitle.radius'));
                                chartDataCopy.legend.data.push(t('message.common.subtitle.vertical'));
                                setOptions(chartDataCopy);
                            } else {
                                setOptions(chartDataInit);
                            }
                        })
                    } else if (sensorPosition.sensorType === 'N') { // 소음센서
                        getDiagnosisResultNoiseByDayByQuery(graphParam).then((data)=>{
                            if (data && data._embedded) {
                                let list = data._embedded.groupByDailyDiagnosisResultNoises;
                                console.log(list)
                                list.sort(function(a,b) {
                                    const upperCaseA = a.ymd.toUpperCase();
                                    const upperCaseB = b.ymd.toUpperCase();
                                    if (upperCaseA > upperCaseB) return 1;
                                    if (upperCaseA < upperCaseB) return -1;
                                    if (upperCaseA === upperCaseB) return 0;
                                });
                                let optionsCopy = {...chartDataInit};
                                let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
                                
                                let rmss = [];
                                let skewness = [];
                                let kurtosis = [];
                                list.map(function(item, i) {
                                    chartDataCopy.xAxis.data.push(item.ymd);
                                    rmss.push(item.rms.toFixed(2));
                                    skewness.push(item.skew.toFixed(2));
                                    kurtosis.push(item.kurtosis.toFixed(2));
                                });
                                chartDataCopy.series.push({name:'RMS', type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : rmss});
                                chartDataCopy.series.push({name:t('message.common.subtitle.skewness'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : skewness});
                                chartDataCopy.series.push({name:t('message.common.subtitle.kurtosis'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : kurtosis});
                                chartDataCopy.legend.data.push('RMS');
                                chartDataCopy.legend.data.push(t('message.common.subtitle.skewness'));
                                chartDataCopy.legend.data.push(t('message.common.subtitle.kurtosis'));
                                setOptions(chartDataCopy);
                            } else {
                                setOptions(chartDataInit);
                            }
                        })
                    }
                } else if (type === "S1") {
                    getEquipmentTemperatureGraphDayByQuery(graphParam).then((data)=>{
                        if (data && data._embedded) {
                            let list = data._embedded.groupByDailyEquipmentTemperatures;
                            list.sort(function(a,b) {
                                const upperCaseA = a.ymd.toUpperCase();
                                const upperCaseB = b.ymd.toUpperCase();
                                if (upperCaseA > upperCaseB) return 1;
                                if (upperCaseA < upperCaseB) return -1;
                                if (upperCaseA === upperCaseB) return 0;
                            });
                            let optionsCopy = {...chartDataInit};
                            let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
                            
                            let temperatures = [];
                            list.map(function(item, i) {
                                chartDataCopy.xAxis.data.push(item.ymd);
                                temperatures.push((item.temperature).toFixed(2));
                            });
                            chartDataCopy.series.push({name:t('message.common.subtitle.temperature'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : temperatures});
                            chartDataCopy.legend.data.push(t('message.common.subtitle.temperature'));
                            setOptions(chartDataCopy);
                        } else {
                            setOptions(null);
                        }
                    })
                }
            }
        } else if (type === "S2" || type === "S3") { // 체인(길이센서)S2, 체인(신율센서)S3
            let graphParam = {...graphDateParam, "equipmentPart.id":equipmentPartId};
            setOptions(null)
            getdDiagnosisResultChainGraphDayByQuery(graphParam).then((data)=>{
                if (data && data._embedded) {
                    let list = data._embedded.groupByDailyDiagnosisResultChains;
                    list.sort(function(a,b) {
                        const upperCaseA = a.ymd.toUpperCase();
                        const upperCaseB = b.ymd.toUpperCase();
                        if (upperCaseA > upperCaseB) return 1;
                        if (upperCaseA < upperCaseB) return -1;
                        if (upperCaseA === upperCaseB) return 0;
                    });
                    let optionsCopy = {...chartDataInit};
                    let chartDataCopy1 = JSON.parse(JSON.stringify(optionsCopy));
                    let chartDataCopy2 = JSON.parse(JSON.stringify(optionsCopy));
                    
                    let lengths = [];
                    let elongs = [];
                    list.map(function(item, i) {
                        chartDataCopy1.xAxis.data.push(item.ymd);
                        chartDataCopy2.xAxis.data.push(item.ymd);
                        lengths.push(item.length.toFixed(2));
                        elongs.push(item.elongation.toFixed(2));
                    });
                    chartDataCopy1.series.push({name:t('message.common.subtitle.length'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : lengths});
                    chartDataCopy2.series.push({name:t('message.common.subtitle.elongation'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : elongs});
                    chartDataCopy1.legend.data.push(t('message.common.subtitle.length'));
                    chartDataCopy2.legend.data.push(t('message.common.subtitle.elongation'));
                    if (type === "S2")
                        setOptions(chartDataCopy1)
                    else if (type === "S3")
                        setOptions(chartDataCopy2)
                } else {
                    setOptions(null)
                }
            })
        }
    }

    useEffect(()=>{
        setSearchStartDateText('');
        setSearchEndDateText('');
        setOptions(null)
        if (type === "S0") { // 진동센서S0, 소음센서S0, 온도센서S1
            if (sensorPosition.sensorType === 'V') {    // 진동센서
                setTitle(t('message.common.chip.vibration.trend.graph'))+" ("+equipmentPartName+"-"+equipmentPartPosition+")";
                setBullet('popbullet.png');
            } else if (sensorPosition.sensorType === 'N') {    // 진동센서
                setTitle(t('message.common.chip.grade.history.trend.graph'))+" ("+equipmentPartName+"-"+equipmentPartPosition+")";
                setBullet('popbullet.png');
            }
        } else if (type === "S1") { // 진동센서S0, 소음센서S0, 온도센서S1
            setTitle(t('message.common.chip.temperature.trend.graph'))
            setBullet('popbullet.png');
        } else if (type === "S2") { // 체인(길이센서)S2
            setTitle(t('message.common.chip.length.trend.graph'))
            setBullet('popbullet.png');
        } else if (type === "S3") { // 체인(신율센서)S3
            setTitle(t('message.common.chip.elongation.trend.graph'))
            setBullet('popbullet.png');
        }
    },[open]);

    return (
        <>
            <div>
                {/* <Chip label={(sensorPosition.sensorType === 'V' ? t('message.common.chip.vibration.trend.graph') : t('message.common.chip.grade.history.trend.graph'))+" ("+equipmentPartName+")"} color="primary" /> */}
                <Button variant="contained" style={{padding:"2px 5px"}} color="info" onClick={handleOpen} >{t('message.common.btn.period.search')}</Button>
            </div>

            <Modal className="pop_box pop_box1" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <MainCard modal darkTitle content={false}>
                <div style={{display:"flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0 10px 0"}}>
                    <div>
                        <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/${bullet}`} alt='' /></span>&nbsp;
                        <Chip label={title} color="success" />
                    </div>

                    <div>
                        <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                            {t('message.common.btn.close')}
                        </Button>
                    </div>
                </div>

                <CardContent>
                    <div style={{display:"flex", alignItems: "center"}}>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                            <CustomDatePicker2 
                                name={"searchStartDateText"} 
                                value={searchStartDateText} 
                                onChange={(e)=>{setSearchStartDateText(e.target.value)}}
                            />
                        </FormControl>
                        <span> ~ </span>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                            <CustomDatePicker2 
                                name={"searchEndDateText"} 
                                value={searchEndDateText} 
                                onChange={(e)=>{setSearchEndDateText(e.target.value)}}
                            />
                        </FormControl>
                        <Button variant="contained" style={{padding:"5px 15px"}} onClick={handleSearch}>
                            <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                        </Button>
                    </div>

                    <div style={{background:"#353535", color:"#fff", height:"50px", width:"800px", padding:"12px", fontSize:"13pt", fontWeight:"bold", borderRadius:"8px"}}>
                        {equipment.name}({equipment.equipmentNo})
                    </div>
                    {(options) &&
                    <div className="row">
                        <div className="mixed-chart" style={{display: "grid"}}>
                        {options &&
                        <MainCard content={false}>
                            <ECharts
                                option={options}
                                opts={{ renderer: 'svg', height: '300px' }}
                            />
                        </MainCard>
                        }
                        </div>
                    </div>
                }
                </CardContent>
                <Divider />
            </MainCard>
            </Modal>
        </>
    )
}

export default EquipmentPartSensorsGraphsLayer;